module.exports = __webpack_public_path__ + "img/logo-tripwe-app.918cb113.png";